export const encodeCountryTaxType = (countryCode, countryTaxType) => `${countryCode}-${countryTaxType}`;

export const decodeCountryTaxType = encodedCTT => {
  const [countryCode, countryTaxType] = encodedCTT.split('-');
  return { countryCode, countryTaxType };
};

export const decodeCountryTaxTypeForObject = ({ countryTaxType, ...rest }) => ({
  ...rest,
  ...decodeCountryTaxType(countryTaxType),
});

export const decodeCountryTaxTypeForArray = array => array.map(decodeCountryTaxTypeForObject);
